import { Flex } from "antd";
import { ImpressaoContainer, ImpressaoHeader } from "components/Impressao";
import type { ApiCalculo } from "pages/calculo/types/ApiCalculo";
import { useMemo } from "react";
import { TableCard } from "./TableCard";

export function TableRelFichaProdutor({ data, title }: { data: ApiCalculo[] | undefined; title: string }) {
	const rows = useMemo(() => (data || []).map((row) => <TableCard calculo={row} key={row?.calc_idpk} />), [data]);

	return (
		<ImpressaoContainer className="w-full mt-3" title={title}>
			<ImpressaoHeader title={title} />

			<Flex vertical={true} gap={"12px"} style={{ width: "100%" }}>
				{rows}
			</Flex>
		</ImpressaoContainer>
	);
}
